import { Stack } from 'expo-router';

import HandleRedirectFromFormerMemberPortal from '../../auth/components/middleware/HandleRedirectFromFormerMemberPortal';
import RedirectIfNotAuthenticated from '../../auth/components/middleware/RedirectIfNotAuthenticated';
import { AuthedUserProvider } from '../../common/providers/AuthedUserProvider';
import InactivityDetector from '../../session/components/InactivityDetector';

export default function FormerMemberLayout() {
    return (
        <RedirectIfNotAuthenticated>
            <AuthedUserProvider>
                <HandleRedirectFromFormerMemberPortal>
                    <InactivityDetector>
                        <Stack
                            screenOptions={{
                                headerShown: false,
                                contentStyle: {
                                    backgroundColor: 'white',
                                },
                            }}
                        />
                    </InactivityDetector>
                </HandleRedirectFromFormerMemberPortal>
            </AuthedUserProvider>
        </RedirectIfNotAuthenticated>
    );
}
